import { NavLink, useParams } from "react-router-dom";
import { SideMenuContainer, SideMenuWrapper } from "./Components";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDashboard, faUsers, faFileAlt, faDollarSign, faUserAlt, faClock, faChevronCircleLeft, faChartArea, faPieChart, faDesktopAlt } from '@fortawesome/free-solid-svg-icons';
import { useApp } from "../../hooks/useApp";
import { ROUTES } from "../../services/constants";
import { useTranslation } from "react-i18next";
import { AppHeaderProfile, AppHeaderProfileAvatar, AppHeaderProfileInfo } from "../../layouts/Components";
import { useAuth } from "../../hooks/useAuth";
import { useEffect, useState } from "react";
import { DataLoading } from "../PreLoader/PreLoader";
import UsersService from "../../services/users.service";
import { uid as userId } from "../../helper";
const SideMenu = () => {
    const {t} = useTranslation()
    const {uid} = useParams();
    const {isShowSideBar, isMobile, setIsShowSideBar} = useApp();
    const {user} = useAuth();
    const [userInfo, setUserInfo] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    useEffect(() => {
        if(uid){
            setIsLoading(true);
            UsersService.profile(uid).then((userInfo) => {
                setUserInfo(userInfo)
                setIsLoading(false)
            });
        }else{
            setUserInfo(user)
            setIsLoading(false)
        }
    }, [uid])
    const onClickMenu = (e) => {
        if(isMobile){
            setIsShowSideBar(false)
        }
    }
    return (
        <SideMenuContainer $isShowSideBar={isShowSideBar}>
            <SideMenuWrapper>
                <AppHeaderProfile>
                    <AppHeaderProfileAvatar><FontAwesomeIcon icon={faUserAlt} /></AppHeaderProfileAvatar>
                    <AppHeaderProfileInfo>
                        {isLoading?(
                            <>
                                <DataLoading small={true} />
                            </>
                        ):(
                            <>
                                <h4>{userInfo.first_name + " " + userInfo.last_name}</h4>
                                <h5>{uid?userId(uid):userInfo.email}</h5>
                            </>
                        )}
                        
                    </AppHeaderProfileInfo>
                </AppHeaderProfile>
                <NavLink to={uid?ROUTES.ACCOUNT_DASHBOARD.replace(':uid', uid):ROUTES.DASHBOARD} className={({ isActive }) => (isActive ? "active-menu" : "")} onClick={onClickMenu}>
                    <FontAwesomeIcon icon={faDashboard} /> {t("Dashboard")}
                </NavLink>
                {!uid && <NavLink to={ROUTES.ALL_USERS} className={({ isActive }) => (isActive ? "active-menu" : "")} onClick={onClickMenu}>
                    <FontAwesomeIcon icon={faUsers} /> {t("All Users List A/Z")}
                </NavLink>}
                <NavLink to={uid?ROUTES.ACCOUNT_PENDING_APPROVAL_PAYMENTS.replace(':uid', uid):ROUTES.PENDING_APPROVAL_PAYMENTS} className={({ isActive }) => (isActive ? "active-menu" : "")} onClick={onClickMenu}>
                    <FontAwesomeIcon icon={faClock} /> {t("Waiting for approvals payments")}
                </NavLink>
                <NavLink to={uid?ROUTES.ACCOUNT_PAYMENTS.replace(':uid', uid):ROUTES.PAYMENTS} end className={({ isActive }) => (isActive ? "active-menu" : "")} onClick={onClickMenu}>
                    <FontAwesomeIcon icon={faDollarSign} /> {t("Payments")}
                </NavLink>
                <NavLink to={uid?ROUTES.ACCOUNT_INVOICES.replace(':uid', uid):ROUTES.INVOICES} className={({ isActive }) => (isActive ? "active-menu" : "")} onClick={onClickMenu}>
                    <FontAwesomeIcon icon={faFileAlt} /> {t("Invoices")}
                </NavLink>
                <NavLink to={uid?ROUTES.ACCOUNT_REPORTS_STATS.replace(':uid', uid):ROUTES.REPORTS_STATS} className={({ isActive }) => (isActive ? "active-menu" : "")} onClick={onClickMenu}>
                    <FontAwesomeIcon icon={faChartArea} /> {t("Yearly and monthly overview")}
                </NavLink>
                <NavLink to={uid?ROUTES.ACCOUNT_REPORTS_PAYMENTS.replace(':uid', uid):ROUTES.REPORTS_PAYMENTS} className={({ isActive }) => (isActive ? "active-menu" : "")} onClick={onClickMenu}>
                    <FontAwesomeIcon icon={faPieChart} /> {t("Yearly and monthly payments")}
                </NavLink>
                <NavLink to={uid?ROUTES.ACCOUNT_MONITORING.replace(':uid', uid):ROUTES.MONITORING} className={({ isActive }) => (isActive ? "active-menu" : "")} onClick={onClickMenu}>
                    <FontAwesomeIcon icon={faDesktopAlt} /> {t("Monitoring")}
                </NavLink>
                {uid && <NavLink to={ROUTES.DASHBOARD} onClick={onClickMenu}>
                    <FontAwesomeIcon icon={faChevronCircleLeft} /> {t("Back to administrator panel")}
                </NavLink>}

            </SideMenuWrapper>
        </SideMenuContainer>
    )
}
export default SideMenu;